jQuery(document).ready(function($) {
    //anchor
    $(document).on('click', '.banner_collection .slider_text_get_started', function(e){
        $('html, body').animate({
            scrollTop: $('.service_type_navigation').offset().top
        }, 500);
    });
});

